import React, { Component } from 'react';

import './assets/plugins/nivo-lightbox/nivo-lightbox.css';
import './assets/plugins/nivo-lightbox/themes/default/default.css';
import './assets/css/main.css';
import './assets/css/themes.dark.css';

import 'font-awesome/css/font-awesome.min.css';
// /themes.light.css

import Header from './components/Header';
import Intro from './components/Intro';
import Skills from './components/Skills';
//import Skills1 from './components/Skills1';
import Experience from './components/Experience';
import Education from './components/Education';
import Profiles from './components/Profiles';
import Certifications from './components/Certifications';
//import Portfolio from './components/Portfolio';
//import Clients from './components/Clients';
import Footer from './components/Footer';
//import Youtube from './components/Youtube';
import $ from 'jquery'
import { listEducation } from './actions/education';
import { listExperience } from './actions/experience';
import { connect } from 'react-redux';
import { introduction } from './actions/introduction';
import { listCertification } from './actions/certification';
import { listSkills } from './actions/skills';
import { listUdemyCourses } from './actions/udemy';
import { listYouTubeVideos} from './actions/youtube';

import ReactGA from 'react-ga';
class App extends Component {

  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    this.getProfileInfo();
    this.initializeReactGA();
    // setTimeout(function () {
    //   this.initializeReactGA();
    // }, 3000);
   // this.getEducationInfo();
   // this.getExperienceInfo();
  }

  initializeReactGA() {
    ReactGA.initialize('UA-124670449-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  getProfileInfo() {
    $.ajax({
      url: 'https://gdkatto8f5.execute-api.ap-southeast-1.amazonaws.com/dev/portfolio/profile',
      dataType: 'json',
      cache: false,
      success: function (data) {
        data = JSON.parse(data); // Mandatory to parse the data to JSON 
       // console.log('Profile Json', data);
        
        //Set education list
        const eduArr = data.educations;
       // console.log(data.educations);
        this.props.store.dispatch(listEducation(eduArr));

        //Set experience list
        const expArr = data.experiences;
      //  console.log(data.experiences);
        this.props.store.dispatch(listExperience(expArr));

        //Set introduction
        const introJson = data.introduction;
        const socialLinks = data.socialLinks;
        let introObj = { introJson: introJson, socialLinks: socialLinks };
      //  console.log(data);
        this.props.store.dispatch(introduction(introObj));

        //Set Certification
        const certArr = data.certifications;
        this.props.store.dispatch(listCertification(certArr));
        //this.props.store.dispatch(listEducation(data));
        //this.setState({ education: data });

        //Set Skills
        const skillsArr = data.skills;
        this.props.store.dispatch(listSkills(skillsArr));

        //Set Courses
        const coursesArr = data.udemyCourses;
        this.props.store.dispatch(listUdemyCourses(coursesArr));
      //  console.log(coursesArr);

        //Set Youtube videos
        const youTubeVideoArr = data.youTubeVideos;
        this.props.store.dispatch(listYouTubeVideos(youTubeVideoArr));


      }.bind(this),
      error: function (xhr, status, err) {
        console.log(err);
      }
    });

  }

  getEducationInfo() {
    $.ajax({
      url: 'https://gdkatto8f5.execute-api.ap-southeast-1.amazonaws.com/dev/portfolio/education',
      dataType: 'json',
      cache: false,
      success: function (data) {
        data = JSON.parse(data); // Mandatory to parse the data to JSON 
      //  console.log(data);
        this.props.store.dispatch(listEducation(data));
        //this.setState({ education: data });
      }.bind(this),
      error: function (xhr, status, err) {
        console.log(err);
      }
    });

  }

  getExperienceInfo() {
    $.ajax({
      url: 'https://gdkatto8f5.execute-api.ap-southeast-1.amazonaws.com/dev/portfolio/experience',
      dataType: 'json',
      cache: false,
      success: function (data) {
        data = JSON.parse(data); // Mandatory to parse the data to JSON 
      //  console.log(data);
        this.props.store.dispatch(listExperience(data));
        //this.setState({ education: data });
      }.bind(this),
      error: function (xhr, status, err) {
        console.log(err);
      }
    });

  }

  render() {
    return (
      <div>
        <div className="c-preloader  js-preloader">
          <div className="c-preloader__spinner  t-preloader__spinner"></div>
        </div>

        <div className="c-main-container  js-main-container">
          <Header></Header>
          <Intro></Intro>
          <Certifications></Certifications>
          <Skills></Skills>
          {/*<Skills1></Skills1>*/}
          <Experience></Experience>
          <Education></Education>
          <Profiles></Profiles>
          {/*<Portfolio></Portfolio>*/}
          {/*<Youtube></Youtube>*/}
          {/*<Clients></Clients>*/}
          <Footer></Footer>
        </div>
      </div>
    );
  }
}

export default connect()(App);



// WEBPACK FOOTER //
// ./src/App.js